var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config && _vm.url)?_c('a',_vm._b({staticClass:"c-long-read-target-toc-link",attrs:{"href":_vm.url},domProps:{"textContent":_vm._s(_vm.name)},on:{"click":_vm.onClick}},'a',_vm.attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }